import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/ins.mp4";
import videoSource1 from "../../assets/videos/Demo-ins.mp4";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/ins-banner.png";

const Inspection = () => {
  pageTitle("Inspection Photo App");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper">
        <img src={AiInvoiceBanner} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">AI-Powered Inspection App </h2>
            <p>Never miss “Before & After” site photos again. </p>
          </div>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            {/* <span class="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            {/* <div class="siw-rpa-text"></div> */}

            <div class="siw-rpa-desc">
              <p>
                The Smart iLab Works <span className="SiW">(SiW)</span>{" "}
                AI-powered Inspection App that automates the documentation
                workflow.
              </p>

              <h3 className="pt-2">Key Capabilities</h3>
              <p className="py-2">
                The AI application simplifies how visual data is captured and
                stored:
              </p>
              <p
                className="pb-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Three-Step Workflow{" "}
              </p>
              <ol>
                <li>
                  Categorized Uploads: After logging in, workers select the
                  specific date, project, and site from a dropdown menu before
                  capturing or uploading photos.
                </li>
                <li>
                  Automated Cloud Storage: The AI automatically creates folders
                  based on the Project, Site, and Date, sending photos to
                  specific locations in SharePoint Cloud in real-time.
                </li>
                <li>
                  Instant Manager Oversight: Managers can review photos as they
                  are uploaded and can immediately request a retake if the
                  quality or content is insufficient.
                </li>
              </ol>
            </div>
          </div>

          <div class="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI-powered app.
            </p>
            <h4>
              Call us at{" "}
              <a href="tel:+6590059743" style={{ color: "rgb(230, 233, 55)" }}>
                +65 9005 9743
              </a>{" "}
              <br></br>
              to explore AI-powered Inspection App.
            </h4>
            <a href="/contact" class="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div class="siw-rpa-desc mt-0">
          <h3>Business Benefits</h3>
          <p className="py-2">
            Moving from manual to AI-driven visual documentation offers several
            advantages:
          </p>
          <ul>
            <li>
              Efficient Reporting: Photos are easily retrieved from
              project-specific folders to generate service reports, leading to
              smoother approval processes.
            </li>
            <li>
              {" "}
              Elimination of Manual Tasks: The system removes the need for
              manual photo searches, significantly reducing administrative time
              and avoiding confusion.
            </li>
            <li>
              Work Justification: Because the app maintains real-time
              information for every photo, it provides clear justification for
              the work performed, ensuring photo accuracy and protecting
              revenue.{" "}
            </li>
          </ul>
        </div>
      </div>
      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing AI-Powered Inspection App
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper siw-project-video-wrapper-portrait">
                <video
                  className="siw-project-video siw-project-video-contain"
                  controls
                >
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the <strong>AI-Powered Inspection App</strong>
            , Click 👉{" "}
            <a
              href="https://ins.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Inspection Photo App
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default Inspection;
